import { faPlus, faUpload } from '@fortawesome/free-solid-svg-icons'
import type { RouteRecordRaw } from 'vue-router'

import i18n from '@/i18n/i18n'
import type { RouteButton } from '@/types/route'

export const SHIPPING_ACTION_REQUIRED_ROUTE = 'parcels.list.actionRequired'
export const SHIPPING_CANCELLED_ROUTE = 'parcels.list.cancelled'
export const SHIPPING_CREATED_LABELS_ROUTE = 'parcels.list.createdLabels'
export const SHIPPING_IN_TRANSIT_ROUTE = 'parcels.list.inTransit'
export const SHIPPING_INCOMING_ORDERS_ROUTE = 'parcels.list.orders'
export const SHIPPING_REPORTS_ROUTE = 'parcels.list.reports'
export const SHIPPING_LABEL_DETAILS_ROUTE = 'parcels.parcel.details'
export const SHIPPING_DUPLICATE_ROUTE = 'parcels.parcel.duplicate'
export const SHIPPING_NEW_SHIPMENT_ROUTE = 'parcels.new'

const SHIPPING_BUTTONS: RouteButton[] = [
  {
    // @ts-ignore
    title: () => i18n.t('New shipment'),
    name: 'parcels.new',
    icon: faPlus,
    mode: 'secondary',
    dataTest: 'smoke-test-new-shipment-form-link',
    dataSmokeTest: 'new-shipment-form-link',
    permissions: ['manage_shipping'],
  },
  {
    title: () => i18n.t('Upload file'),
    name: 'base.csv-importer.upload',
    icon: faUpload,
    mode: 'borderless',
    permissions: ['import_orders'],
  },
]

export default [
  // SHIPPING https://sendcloud.atlassian.net/browse/SC-19980
  {
    name: SHIPPING_INCOMING_ORDERS_ROUTE,
    path: '/shipping/list/orders',
    component: () => import('@/app/parcels/views/IncomingOrders.vue'),
    props: (route: RouteRecordRaw & { query: any, params: any }): { stateParams: any } => ({
      stateParams: { ...route.query, ...route.params },
    }),
    meta: {
      pageTitle: () => i18n.t('Incoming orders'),
      permissions: ['process_orders'],
      buttons: SHIPPING_BUTTONS,
    },
  },
  {
    name: SHIPPING_CREATED_LABELS_ROUTE,
    path: '/shipping/list/labels',
    component: () => import('@/app/parcels/views/CreatedLabels.vue'),
    meta: {
      pageTitle: () => i18n.t('Created labels'),
      permissions: ['view_parcels'],
      buttons: SHIPPING_BUTTONS,
    },
  },
  {
    name: SHIPPING_IN_TRANSIT_ROUTE,
    path: '/shipping/list/in-transit',
    component: () => import('@/app/parcels/views/ShippedView.vue'),
    meta: {
      pageTitle: () => i18n.t('Shipped'),
      permissions: ['view_parcels'],
      buttons: SHIPPING_BUTTONS,
    },
  },
  {
    name: SHIPPING_CANCELLED_ROUTE,
    path: '/shipping/list/cancelled',
    component: () => import('@/app/parcels/views/CancelledView.vue'),
    meta: {
      pageTitle: (): string => 'Cancelled',
      permissions: ['view_parcels'],
      buttons: SHIPPING_BUTTONS,
    },
  },
  {
    name: SHIPPING_ACTION_REQUIRED_ROUTE,
    path: '/shipping/list/pending',
    component: () => import('@/app/parcels/views/ActionRequired.vue'),
    meta: {
      pageTitle: () => i18n.t('Action required'),
      permissions: ['manage_shipping'],
      buttons: SHIPPING_BUTTONS,
    },
  },
  {
    name: SHIPPING_REPORTS_ROUTE,
    path: '/shipping/list/reports',
    component: () => import('@/app/parcels/views/ReportsView.vue'),
    meta: {
      pageTitle: (): string => 'Reports',
      permissions: ['manage_pickup_reports'],
      buttons: SHIPPING_BUTTONS,
    },
  },
  {
    name: SHIPPING_NEW_SHIPMENT_ROUTE,
    path: '/shipping/new',
    component: () => import('@/app/parcels/views/NewShipmentView.vue'),
    meta: {
      pageTitle: () => i18n.t('Create new shipment'),
      permissions: ['manage_shipping'],
    },
  },
  {
    name: SHIPPING_LABEL_DETAILS_ROUTE,
    path: '/shipping/:id/details',
    component: () => import('@/app/parcels/views/LabelDetailsView.vue'),
    props: (route: RouteRecordRaw & { params: { id: string } }): { parcelId: number } => ({
      parcelId: Number.parseInt(route.params.id),
    }),
    meta: {
      pageTitle: () => i18n.t('Label details'),
      permissions: ['view_parcels'],
    },
  },
  {
    name: SHIPPING_DUPLICATE_ROUTE,
    path: '/shipping/:id/duplicate',
    component: () => import('@/app/parcels/views/DuplicateShipmentView.vue'),
    props: (route: RouteRecordRaw & { params: { id: string } }): { parcelId: number } => ({
      parcelId: Number.parseInt(route.params.id),
    }),
    meta: {
      pageTitle: () => i18n.t('Duplicate shipment'),
      permissions: ['manage_shipping'],
    },
  },
] satisfies RouteRecordRaw[]
